import React from "react";
import G1 from '../../Images/New/AllFeature/1.gif'
import G2 from '../../Images/New/AllFeature/2.gif'
import G3 from '../../Images/New/AllFeature/3.gif'
import G4 from '../../Images/New/AllFeature/4.gif'
import G5 from '../../Images/New/AllFeature/5.gif'
import G6 from '../../Images/New/AllFeature/6.gif'
import G7 from '../../Images/New/AllFeature/7.gif'
import G8 from '../../Images/New/AllFeature/8.gif'
import G9 from '../../Images/New/AllFeature/9.gif'
import G10 from '../../Images/New/AllFeature/10.gif'
import G11 from '../../Images/New/AllFeature/11.gif'
import G12 from '../../Images/New/AllFeature/12.gif'
import G13 from '../../Images/New/AllFeature/13.gif'
import G14 from '../../Images/New/AllFeature/14.gif'
import G15 from '../../Images/New/AllFeature/15.gif'

const FeatureItem = ({ children, img, Desp }) => (
  <div className="bg-[#ffffff] py-5 px-3 rounded-lg group border border-[#b5d0ff] hover:scale-105 duration-150 hover:shadow-lg ">
    <div className="flex flex-col justify-center items-center">
      <img src={img} className="w-14 mr-4 mb-2" alt="" />
      <div>
        <p className="mb-0 text-2xl text-center font-semibold text-[#2a3742] group-hover:text-blue-700">
          {children}
        </p>
        <p className="flex mt-2 text-lg text-center">
          {Desp}
        </p>
      </div>
    </div>
  </div>
);

const AllFeatures = () => {
  return (
    <div className="relative bg-[#ffffff] py-10 sm:py-20 sm:px-12 flex flex-col justify-center items-center px-3 ">
      <div className="text-center mb-4">
        <p className="text-4xl text-black font-bold">
          Manage your TDS return filing effortlessly with{" "}
          <span
            className="font-extrabold"
            style={{
              backgroundImage:
                "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            EasyOFFICE
          </span>
        </p>
        <p className="text-2xl mt-1 italic">
          The Best TDS filing software for CA firms and enterprises.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-1 items-center bg-[#f1f5f8] p-3 sm:p-10 w-full max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <FeatureItem
            img={G1}
            Desp={
              "Filing of TDS / TCS Returns (Regular or Correction) Directly Online to Income Tax India Portal"
            }
          >
            Prepare & Upload <br />
            TDS & TCS Returns
          </FeatureItem>
          <FeatureItem
            img={G2}
            Desp={
              "Auto Generation of Form 16, 16A, 27D in PDF Format and Signed with a Digital Signature along with the Email Facility"
            }
          >
            TDS / TCS Certificates
          </FeatureItem>
          <FeatureItem
            img={G3}
            Desp={"Direct Uploading of 15G and 15H on ITD portal "}
          >
            15G and 15H Forms
          </FeatureItem>
          <FeatureItem
            img={G4}
            Desp={
              "Data validation process uses the NSDL utility to check the entered data against a set of predefined rules and standards "
            }
          >
            Data Validation through integrated utility
          </FeatureItem>
          <FeatureItem
            img={G5}
            Desp={
              " E-Payment of Dues from software ITNS-281 & others along with the challan printing and Online Challan Verification is Available "
            }
          >
            Challan E-payment & Verification
          </FeatureItem>
          <FeatureItem
            img={G6}
            Desp={
              "Justification report request and generate justification in excel file"
            }
          >
            Justification Report
          </FeatureItem>
          <FeatureItem
            img={G7}
            Desp={
              "Facility to import / export data from consolidated file (. tds file), .txt file & Excel sheets. "
            }
          >
            Import & Export facility
          </FeatureItem>
          <FeatureItem
            img={G8}
            Desp={"Bulk PAN Verification for all Deductees & Employees"}
          >
            Bulk PAN Verification
          </FeatureItem>
          <FeatureItem
            img={G9}
            Desp={
              "Multiple Validations for Default Predictions to trace errors before uploading the return "
            }
          >
            Pre-validation Facility
          </FeatureItem>
          <FeatureItem
            img={G10}
            Desp={"Automatic Calculation of Interests and Late Fee "}
          >
            Interest and Late Fee Calculation
          </FeatureItem>
          <FeatureItem
            img={G11}
            Desp={
              "Provides several important registers such as Certificate Register, Challan Register, TDS Register, Deductee / Employee wise Transactions Report, TDS Report for Audit, Unconsumed Challan etc."
            }
          >
            Reports & Analysis
          </FeatureItem>
          <FeatureItem
            img={G12}
            Desp={
              "Compliance check to charge TDS at a higher rate in certain cases"
            }
          >
            Compliance check for <br />
            206AB and 206CCA
          </FeatureItem>
          <FeatureItem
            img={G13}
            Desp={
              "Facility to Request at TDSCPC for consolidated file, justification, Report Correction etc. and facility to Download files in software."
            }
          >
            Request at TDSCPC
          </FeatureItem>
          <FeatureItem
            img={G14}
            Desp={
              "Preparation & E-filing of form 24Q, 26Q, 27Q, 27EQ with pre-validation facility"
            }
          >
            E-filing of Returns
          </FeatureItem>
          <FeatureItem
            img={G15}
            Desp={
              "Calculation of Annual Salary after Giving an Effect of the standard deduction and Deductions under Chapter VI-A along with Calculation of Month-wise Salary and TDS thereon"
            }
          >
            Employees’ Annual Taxable <br />
            Salary Calculations
          </FeatureItem>
        </div>
      </div>
      <div className="w-full flex justify-end max-w-7xl">
        <a
          href="https://www.easyofficesoftware.com/tdssoftware"
          className="flex ml-5"
          target="_blank"
          rel="noreferrer"
        >
          <p className="text-xl font-bold">Learn More</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right mt-[6px] ml-1"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default AllFeatures;
